/**
 * @param instance - La instancia de Vue.
 * @param text - El texto de la notificación.
 * @param title - El título de la notificación.
 * @param options - Opciones adicionales para la notificación.
 */
export const showNotification = (instance, text, title, options) => {
  instance.$vs.notify({
    title,
    text,
    color: 'primary',
    iconPack: 'feather',
    position: 'bottom-right',
    time: 4000,
    ...options,
  });
};

/**
 * Notificación de error en el formulario.
 * @param instance - La instancia de Vue.
 * @param options - Opciones de vuesax notify.
 */
export const showInvalidFormNotification = (instance, options) => {
  showNotification(instance, 'Revisa los campos marcados en rojo', 'Ups!', {
    color: 'danger',
    icon: 'icon-alert-circle',
    ...options,
  });
};
